/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { cloneDeep, sum, trim } from "lodash";
import React, { useEffect, useState } from "react";
import LabelInput from "../../common/LabelInput";
import Body from "../../components/Body";
import config from "../../config/config";
import InputTable from "../../common/InputTable";
import numberFormat from "../../common/numberFormat";
import LabelText from "../../common/LabelText";
import DetailBlock from "../../common/DetailBlock";
import AppButton from "../../common/AppButton";
import removeCommas from "../../common/removeCommas";
import { deserializeTable, serializeTable } from "../../common/serialize";
import addPrecision from "../../common/addPrecision";
import api from "../../config/api";
import focusInputByName from "../../common/focusInputByName";
import { IoLocationSharp } from "react-icons/io5";
import { AiFillCalendar } from "react-icons/ai";
import { Checkbox, FormControlLabel } from "@mui/material";
import AppInput from "../../common/AppInput";
import colors from "../../config/colors";
import { observer } from "mobx-react-lite";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

const headers = [
  {
    label: "Service Description",
    name: "serviceDescription",
    style: { width: 500, backgroundColor: "#77777720" },
  },
  { label: "Hours", name: "hourse", style: { backgroundColor: "#77777720" } },
  { label: "Rate ($)", name: "rate", style: { backgroundColor: "#77777720" } },
  {
    label: "Amount",
    name: "amount",
    style: {
      width: 200,
      padding: "10px",
      backgroundColor: "#77777720",
    },
  },
];

const datamodel = [
  [
    {
      placeholder: "",
      name: "serviceDescription",
      value: "",
      multiline: true,
    },
    {
      placeholder: "",
      name: "hours",
      value: "",
      numberFormat: true,
    },
    {
      placeholder: "",
      name: "rate",
      value: "",
      numberFormat: true,
    },
    {
      placeholder: "",
      name: "amount",
      value: "",
      numberFormat: true,
    },
  ],
];

const formInit = {
  quoteId: "",
  quotationIssueDate: new Date(),
  jobStartDate: "",
  jobEndDate: "",
  quotationDeadline: new Date(new Date().setMonth(new Date().getMonth() + 1)),
  tax: config.HST,
  location: "",
  quotationTo: "",
  helpText: `Note: The prices quoted above are applicable only to the specific job/service described in this quotation. This quotation is valid for 30 days from the issue date, and the exact expiry date is stated explicitly within the document.`,
};

function QuotationCreate() {
  const [disabled, setDisabled] = useState(false);
  const [form, setForm] = useState({ ...formInit });
  const [data, setData] = useState(cloneDeep(datamodel));
  const navigate = useNavigate();
  const params = useParams();
  const { pathname, state } = useLocation();
  const queryClient = useQueryClient();

  const loadQuote = async () => {
    setForm((cur) => ({
      ...cur,
      ...state.data,
    }));

    const deserializedDetailsTable = deserializeTable(state.data.detailsTable);
    setData([...deserializedDetailsTable]);
  };

  const genID = async () => {
    const res = await api.get("generate/quotation");
    if (!res.ok) return toast.error(res.originalError.message);
    setForm((cur) => ({ ...cur, quoteId: res.data }));
  };

  useEffect(() => {
    if (pathname.endsWith("edit")) {
      loadQuote();
    } else {
      genID();
    }
  }, []);

  const handleSubmit = async (event) => {
    setDisabled(true);
    event.preventDefault();

    const found = [
      "tax",
      "jobEndDate",
      "jobStartDate",
      "location",
      "quotationTo",
    ].filter((i) => {
      if (!form[i]) {
        focusInputByName(i);
        return i;
      }
      return false;
    });
    if (found.length > 0) {
      return false;
    }

    const detailsTable = serializeTable(data, "name", "value");

    const formData = {
      ...form,
      detailsTable: detailsTable.filter((i) => i.serviceDescription),
      total: numberFormat(total),
      subtotal: numberFormat(subtotal),
      taxPercentage: tax,
    };

    let res;
    if (pathname.endsWith("edit")) {
      res = await api.put("quotations", formData);
    } else {
      res = await api.post("quotations", formData);
    }

    if (!res.ok) return toast.error(res.originalError.message);
    queryClient.invalidateQueries(["quotations"]);
    pathname.endsWith("edit")
      ? toast.success("Quotation has been successfully updated. ")
      : toast.success("Quotation has been successfully created. ");

    setDisabled(false);
    const path = `/quotations/${res.data._id}/quotationToPdf`;
    navigate(path, { replace: true });
  };

  const handleChange = ({ target }) => {
    const name = target.name;
    const value = target.value;

    if (name === "quotationIssueDate") {
      setForm({
        ...form,
        [name]: value,
        quotationDeadline: new Date(
          new Date(value).setMonth(new Date(value).getMonth() + 1)
        ),
      });
    } else {
      if (name === "jobStartDate") {
        if (new Date(form.jobEndDate).valueOf() < new Date(value).valueOf()) {
          delete form.jobEndDate;
        }
      }
      setForm({ ...form, [name]: value });
    }
  };

  const handleSelect = ({ target }) => {
    const name = target.name;
    const value = target.value;
    if (value[0])
      setForm({
        ...form,
        [name]: value,
        attention: `${value[0].incharge}\n${value[0].tag}`,
      });
  };
  const handleInputChange = ({
    event,
    value,
    row,
    column,
    numberFormat: num,
    noDigits,
  }) => {
    event.preventDefault();
    let vl = value;
    if (num) {
      vl = numberFormat(value);
    }
    if (noDigits) {
      vl = vl.replace(".", "");
    }
    const dt = [...data];
    if (column === 1 || column === 2) {
      const hours = +dt[row][1].value;
      const rate = +dt[row][2].value;
      const amount = hours * rate;
      dt[row][3].value = amount;
    }

    dt[row][column].value = vl;
    setData(dt);
  };

  const handleAddNewRow = () => {
    const dt = cloneDeep(datamodel);
    setData([...data, ...dt]);
  };

  const {
    quoteId,
    quotationIssueDate,
    jobStartDate,
    jobEndDate,
    quotationDeadline,
    tax,
    helpText,
    location: loc,
    quotationTo,
  } = form;

  const tableData = serializeTable(data, "name", "value");
  const subtotal = sum(tableData.map((i) => Number(removeCommas(i.amount))));
  const taxValue = +Math.fround(subtotal * (1 + 0.01 * tax)).toFixed(3);
  const total = taxValue;
  const size = config.iconSize;

  return (
    <Body title="Create Quotation">
      <form onSubmit={handleSubmit} noValidate={false}>
        <div>
          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            <DetailBlock
              style={{
                boxShadow: "none",
                width: "100%",
                backgroundColor: "transparent",
              }}
            >
              <div
                className="d-flex"
                style={{
                  justifyContent: "space-between",
                  marginBottom: 30,
                }}
              >
                <LabelText columnMode label="Quote ID" value={quoteId} />
              </div>
            </DetailBlock>
            <DetailBlock style={{ width: "100%" }}>
              <div className="d-flex justify-content-center">
                <div
                  className="d-flex"
                  style={{
                    width: 800,
                    flexWrap: "wrap",
                    gap: "0px 40px",
                    justifyContent: "center",
                    marginBottom: 30,
                  }}
                >
                  <div
                    className="d-flex"
                    style={{
                      justifyContent: "space-between",
                      width: 800,
                      gap: 20,
                    }}
                  >
                    <AppInput
                      type="date"
                      label="Issue Date"
                      onChange={handleChange}
                      name="quotationIssueDate"
                      placeholder="Quotation Issue Date"
                      value={new Date(quotationIssueDate)}
                      leftIcon={
                        <AiFillCalendar
                          color={colors.silver}
                          size={config.iconSize}
                        />
                      }
                      floatLabel
                      required
                    />
                    <AppInput
                      onChange={handleChange}
                      name="jobStartDate"
                      label="Job Start Date"
                      placeholder="Job Start Date"
                      datePicker
                      floatLabel
                      value={jobStartDate ? new Date(jobStartDate) : ""}
                      required
                      type="date"
                      leftIcon={
                        <AiFillCalendar
                          color={colors.silver}
                          size={config.iconSize}
                        />
                      }
                    />
                    <AppInput
                      onChange={handleChange}
                      name="jobEndDate"
                      label="Job End Date"
                      placeholder="Job End Date"
                      datePicker
                      minDate={jobStartDate ? new Date(jobStartDate) : ""}
                      value={jobEndDate ? new Date(jobEndDate) : ""}
                      required
                      floatLabel
                      type="date"
                      leftIcon={
                        <AiFillCalendar
                          color={colors.silver}
                          size={config.iconSize}
                        />
                      }
                    />
                  </div>
                  <AppInput
                    type="text"
                    label="Job Location"
                    name="location"
                    chip
                    onChange={handleChange}
                    leftIcon={<IoLocationSharp size={size} color={"silver"} />}
                    style={{ width: 800 }}
                    filterBy="name"
                    value={loc}
                    required
                    floatLabel
                  />
                  <LabelInput
                    onChange={handleChange}
                    forceLabel={
                      <b
                        style={{
                          color: "#8a8a8aff",
                          paddingLeft: "0.5rem",
                          fontSize: "1rem",
                          fontWeight: 400,
                          display: "flex",
                          alignItems: "center",
                          columnGap: "0.5rem",
                        }}
                      >
                        <IoLocationSharp size={size} color={"silver"} />
                        Quotation To
                      </b>
                    }
                    multiline
                    name="quotationTo"
                    style={{ maxWidth: "100%", width: 800, minHeight: 50 }}
                    value={quotationTo}
                  />
                </div>
              </div>
            </DetailBlock>
            <DetailBlock style={{ width: "100%" }}>
              <br />
              <div
                className="d-flex"
                style={{
                  alignItems: "flex-end",
                  flexDirection: "column",
                  marginTop: 20,
                }}
              >
                <InputTable
                  className="table-bordered"
                  headers={headers}
                  list={data}
                  onInputChange={handleInputChange}
                  addNewRow={handleAddNewRow}
                />
                <div
                  style={{
                    display: "flex",
                    width: 300,
                    gap: 10,
                    flexDirection: "column",
                  }}
                >
                  <LabelText
                    label="Subtotal"
                    value={`$ ${addPrecision(numberFormat(subtotal))}`}
                    name="subtotal"
                  />
                  <LabelInput
                    onChange={handleChange}
                    style={{
                      width: 140,
                      backgroundColor: "transparent",
                    }}
                    forceLabel="HST ( % )"
                    rowMode
                    name="tax"
                    required
                    value={tax && numberFormat(tax)}
                  />
                  <LabelText
                    label="Total"
                    value={`$ ${addPrecision(numberFormat(total))}`}
                  />
                </div>
              </div>
            </DetailBlock>
            <DetailBlock style={{ width: "100%" }}>
              <div>
                <div style={{ maxWidth: 200 }}>
                  <AppInput
                    type="date"
                    label="Quotation Deadline"
                    onChange={handleChange}
                    name="quotationDeadline"
                    placeholder="Quotation Deadline"
                    value={new Date(quotationDeadline)}
                    leftIcon={
                      <AiFillCalendar
                        color={colors.silver}
                        size={config.iconSize}
                      />
                    }
                    floatLabel
                    required
                    style={{ maxWidth: 200 }}
                  />
                </div>

                <LabelInput
                  onChange={handleChange}
                  forceLabel={<b>Body Text</b>}
                  multiline
                  name="helpText"
                  style={{ maxWidth: "100%", minHeight: 100 }}
                  value={helpText}
                />
              </div>
            </DetailBlock>
          </div>
          <div style={{ margin: "20px 0px" }}>
            <AppButton
              disabled={disabled}
              type="button"
              onClick={handleSubmit}
              text={
                pathname.endsWith("edit")
                  ? "Update Quotation"
                  : "Create Quotation"
              }
              className="btn-primary"
            />
          </div>
        </div>
      </form>
    </Body>
  );
}
export default observer(QuotationCreate);
